//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "material-quota-manage",
  data() {
    return {
      tabIndex: 1,
      refresh:true,
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '价格审批',
        url: 'api/paPrcapp/page',
        workflowSearchBean: {},
        tabList:['查询价格审批','价格审批待办'],
        fixRules: [],
        inputCondition: {
          placeholder: '标题/创建人',
          searchCondition: 'key',
          rules: [{
            field: "orderNo-docTitle-creator",
            option: "LIKE_ANYWHERE"
          }]
        }
      },
      configTodo: {
        title: '价格审批',
        url: 'api/paPrcapp/page',
        workflowSearchBean: {},
        tabList:['查询价格审批','价格审批待办'],
        fixRules: [],
        inputCondition: {
          placeholder: '标题/创建人',
          searchCondition: 'key',
          rules: [{
            field: "orderNo-docTitle-creator",
            option: "LIKE_ANYWHERE"
          }]
        }
      },
      searchData: {},
      list: [],
      showMore: true
    }
  },
  methods: {
    goDetail(requestId){
      this.$router.push('/workflow/'+requestId+'?component=PriceApprovalViewComponent')
    },
    getTabIndex(e) {
      this.tabIndex = e;
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop() {
      this.$refs.header.getlist(true);
    },
    loadBottom() {
      this.$refs.header.getMore();
    },

    getWorkFlow() {
      this.$get('api/biz-object-parameters/key/priceApproval').then(data => {
        this.config.workflowSearchBean = {
          workflowId: data.workflowType
        };
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchType: '0',
        };
        this.$refs.header.getlist();
      })
    },
  },
  mounted() {
    this.init();
    this.$refs.header.tabIndex = this.$route.query.tabIndex || 1;
    this.tabIndex = this.$route.query.tabIndex || 1;
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/price-approval/price-approval-list.vue